import { Avatar, Button, Icon, IconKey } from '@platform/components';

type UploadButtonProps = {
  onClick?: () => void;
  hintText?: string;

  defaultIcon?: IconKey;
  avatarUrl?: string;
  text: string;

  middleIcon?: IconKey | JSX.Element;
};

export const UploadButton = (props: UploadButtonProps) => {
  const { onClick, text, defaultIcon, avatarUrl, hintText, middleIcon } = props;
  return (
    <div className='flex flex-col gap-4 text-md'>
      <Button
        additionalClassnames='px-4 py-4 h-[136px] md:h-[96px] w-full bg-gray-25!'
        variant='secondary-gray'
        size='md'
        type='button'
        onPress={onClick}
      >
        <div className='w-full h-full flex flex-col md:flex-row gap-4 items-center justify-start text-gray-600 font-semibold'>
          {defaultIcon && !avatarUrl && (
            <Avatar renderAsDiv={true} type='icon' size='2xl' icon={defaultIcon} />
          )}
          {avatarUrl && (
            <Avatar renderAsDiv={true} type='avatar' size='2xl' avatarUrl={avatarUrl} />
          )}
          <div className='flex flex-row gap-2'>
            {middleIcon && typeof middleIcon === 'string' && <Icon type={middleIcon} size='20' />}
            {middleIcon && typeof middleIcon !== 'string' && middleIcon}
            {text}
          </div>
        </div>
      </Button>
      <div className='text-gray-500 text-sm text-center w-full'>{hintText}</div>
    </div>
  );
};
